import React, { useEffect, useState } from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import SellerCard from '../../components/admin/SellerCard';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import EmptyState from '../../components/common/EmptyState';
import { useToast } from '../../components/common/Toast';
import { adminService } from '../../services/admin.service';
import { theme } from '../../config/theme';
import { ONBOARDING_STATUS } from '../../config/constants';

const SellerManagement = () => {
  const toast = useToast();
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    fetchSellers();
  }, [filter]);

  const fetchSellers = async () => {
    setLoading(true);
    try {
      const response = await adminService.getAllSellers(1, 20, filter);
      setSellers(response.data?.data || []);
    } catch (error) {
      toast.error('Failed to load sellers');
    } finally {
      setLoading(false);
    }
  };

  const filterButtonStyles = (active) => ({
    padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
    border: `1px solid ${active ? theme.colors.primary.main : theme.colors.gray[300]}`,
    borderRadius: theme.borderRadius.md,
    background: active ? theme.colors.primary.main : theme.colors.white,
    color: active ? theme.colors.white : theme.colors.text.primary,
    cursor: 'pointer',
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: theme.typography.fontSize.sm,
    transition: theme.transitions.base,
  });

  if (loading) return <LoadingSpinner fullScreen />;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl }}>
        <h1 style={{ fontSize: theme.typography.fontSize['3xl'], fontWeight: theme.typography.fontWeight.bold, marginBottom: theme.spacing.xl }}>
          All Sellers
        </h1>

        <div style={{ display: 'flex', gap: theme.spacing.md, marginBottom: theme.spacing.xl, flexWrap: 'wrap' }}>
          <button style={filterButtonStyles(filter === null)} onClick={() => setFilter(null)}>All</button>
          <button style={filterButtonStyles(filter === ONBOARDING_STATUS.APPROVED)} onClick={() => setFilter(ONBOARDING_STATUS.APPROVED)}>Approved</button>
          <button style={filterButtonStyles(filter === ONBOARDING_STATUS.UNDER_REVIEW)} onClick={() => setFilter(ONBOARDING_STATUS.UNDER_REVIEW)}>Under Review</button>
          <button style={filterButtonStyles(filter === ONBOARDING_STATUS.REJECTED)} onClick={() => setFilter(ONBOARDING_STATUS.REJECTED)}>Rejected</button>
        </div>

        {sellers.length === 0 ? (
          <EmptyState title="No sellers found" />
        ) : (
          <div style={{ display: 'grid', gap: theme.spacing.md }}>
            {sellers.map(seller => <SellerCard key={seller.id} seller={seller} />)}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default SellerManagement;